import { ccs } from "../types";
import lambdas from "../lambdas/apis"
import { call, put, select, takeEvery } from "redux-saga/effects";
import { getFileType, uploadFileToS3WithSignedUrl } from "../utils/common";
import { v4 as uuidv4 } from 'uuid'
import { getUser } from "../selectors/user";

export function* uploadFiles(action) {
      let { _id, conversationId, files, captions, useConversationId, bot = false, isSignOff } = action.payload;
      files = new Array(...files);

      try {
          const filesData = files.map(file => ({
              fileName: file.name,
              type: getFileType(file.type),
              mimeType: file.type,
              caption: captions[file.name]
          }));
          const messageId = uuidv4();

          const user = yield select(getUser)
          if (_id) {
              yield put({
                  type: ccs.CCS_ADD_TO_MESSAGE_QUEUE_REQUEST, payload: {
                      action: 'sendMessage', message: {
                          _id: messageId,
                          messageId,
                          conversation: _id,
                          type: 'attachments',
                          attachments: filesData,
                          from: {
                              userId: user.id,
                              email: user.email,
                              mobile: user.mobile,
                              role: user.role.role_name,
                              roleId: user.role.id,
                              username: `${user.first_name} ${user.last_name}`
                          }
                      }
                  }
              });
          }
          const response = yield call(lambdas.ccs.uploadFiles, {}, { _id: _id || conversationId }, {}, { filesData, messageId, useConversationId, bot });
          if (response.data.code === 200) {
              yield* response.data.data.map(({ signedUrl, fileName }) => {
                  const file = files.find(f => f.name === fileName);
                  return call(uploadFileToS3WithSignedUrl, signedUrl, file);
              })
              const saveResponse = yield call(lambdas.ccs.saveAndBroadcastMessage, {}, { _id: _id || conversationId }, {}, {
                  message: {
                      type: 'attachments',
                      messageId,
                      attachments: response.data.data
                  },
                  bot,
                  useConversationId,
                  isSignOff
              });
              yield put({ type: ccs.CCS_UPLOAD_FILES_SUCCESS, payload: { _id: saveResponse.data.data.conversation._id, isSignOff, media: saveResponse.data.media } });
          } else {
              yield put({ type: ccs.CCS_UPLOAD_FILES_FAILURE, payload: { message: 'Could not upload files' } });
          }
      } catch (error) {
          yield put({ type: ccs.CCS_UPLOAD_FILES_FAILURE, payload: { message: error } });
      }
  }

  export function* addToMessageQueue(action) {
    yield put({ type: ccs.CCS_ADD_TO_MESSAGE_QUEUE_SUCCESS, payload: action.payload });
}


export default function* ccsSaga() {
      yield takeEvery(ccs.CCS_UPLOAD_FILES_REQUEST, uploadFiles)
      yield takeEvery(ccs.CCS_ADD_TO_MESSAGE_QUEUE_REQUEST, addToMessageQueue)
}